import { render, staticRenderFns } from "./PatientSelection.vue?vue&type=template&id=2b0c8992&scoped=true"
import script from "./PatientSelection.vue?vue&type=script&lang=js"
export * from "./PatientSelection.vue?vue&type=script&lang=js"
import style0 from "./PatientSelection.vue?vue&type=style&index=0&id=2b0c8992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c8992",
  null
  
)

export default component.exports